import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DatePicker from 'react-datepicker';

const ProfileDatePickerInput = ({
  field: { name, value, onBlur },
  form: { errors, touched, setFieldValue },
  id,
  label,
  disabled,
  isMobile,
  // className,
  // ...props
}) => {
  const hasError = errors[name] && touched[name];
  const labelClassName = classnames('label profile-label', { 'is-invalid': hasError });
  const fieldClassName = classnames('profile-input', { 'profile-input-sm': isMobile, 'is-invalid': hasError });
  return (
    <div className="field">
      {label && <label className={labelClassName}>{label}</label>}
      <div className="control">
        <DatePicker
          className={fieldClassName}
          name={name}
          id={id}
          selected={value}
          onBlur={onBlur}
          onChange={date => {
            setFieldValue(name, date);
          }}
          showYearDropdown
          showMonthDropdown
          dateFormat="dd.MM.yyyy"
          disabled={disabled || false}
        />
      </div>
      {hasError && <p className="profile-input-message is-invalid">{errors[name]}</p>}
    </div>
  );
};

ProfileDatePickerInput.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default ProfileDatePickerInput;
